import { TranslateFactoryService, CommonsSessionStorageService } from 'ib-web-commons/utils';
import * as angular from 'angular';
import { GiftCardsDatalayerService } from './app/core/services/ib-gift-cards-datalayer-service';
import { downgradeComponent } from '@angular/upgrade/static';
import { IbGiftCardsBannerPromotionComponent } from '@src/app/features/pages/configuration/components/ib-gift-cards-banner-promotion/ib-gift-cards-banner-promotion.component';
import { SecurityOtpService } from 'ib-web-commons/security';


class InitApp {

    constructor (
        $translate: angular.translate.ITranslateService,
        private $rootScope: CommonsRootScope,
        private GiftCardsAppConstants: GiftCardsAppConstant,
        private CommonsLanguageAndMarketService: any,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private GiftCardsUtilService: any,
        private MonetateUtilsService: any,
        private CommonsGetLoginInfoService: CommonsGetLoginInfoService,
        private TranslateFactoryService: TranslateFactoryService,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private GiftCardsDatalayerService: GiftCardsDatalayerService,
        private SecurityOtpService: SecurityOtpService
    ) {
        //Set translation language to use
        $translate.use(this.GiftCardsAppConstants.lang);
        this.TranslateFactoryService.setLanguage(this.GiftCardsAppConstants.lang);
        this.$rootScope.appLang = this.GiftCardsAppConstants.lang;
        this.$rootScope.appMarket = this.GiftCardsAppConstants.market;
        this.$rootScope.backGroundImage = this.GiftCardsUtilService.getBackGroundURL();
        this.$rootScope.paymentBackgroundImageUrl = this.$rootScope.backGroundImage;
        this.$rootScope.routes = {
            icons: this.GiftCardsAppConstants.iconsRoute,
            images: this.GiftCardsAppConstants.imagesRoute,
            templates: this.GiftCardsAppConstants.templatesRoute,
            links: this.GiftCardsAppConstants.linksRoute
        };
        this.$rootScope.serviceURI = this.GiftCardsAppConstants.servicesURI;
        this.$rootScope.hideAdvancedSearch = true;
        this.$rootScope.phonesList = {};
        this.$rootScope.fullWidth = false;
    }
    active = ():void => {
        this.CommonsSessionStorageService.setPrefix('ib-gift-cards-app');
        this.GiftCardsUtilService.initStorage();
        this.localStorageService.set('flowApp', this.GiftCardsAppConstants.FLOWAPP);
        //Initilize language and market
        const marketLang = this.CommonsLanguageAndMarketService.init();
        const isContributionFlow = this.GiftCardsUtilService.isContributionFlow();
        this.GiftCardsUtilService.updateMarketLang(marketLang);
        this.GiftCardsUtilService.getLoggedCookiesInfo(isContributionFlow);
        this.GiftCardsDatalayerService.initialDatalayer();
        this.CommonsSessionStorageService.set('TrackingCode', marketLang.language + '/' + marketLang.market + '/' + this.GiftCardsAppConstants.QUADRIGAMS.REGALO);
        this.GiftCardsDatalayerService.addInitialProcessAndStep();
        this.GiftCardsUtilService.initThemeQuadrigamLocal();
        this.MonetateUtilsService.initializeMonetate(this.GiftCardsAppConstants.lang, this.GiftCardsAppConstants.market, this.GiftCardsUtilService.getDeviceType());
        this.CommonsGetLoginInfoService.checkCustomerStatus(true);
        this.GiftCardsDatalayerService.updateStepWithQuadrigam();
        this.GiftCardsUtilService.initTitle();

        this.$rootScope.$on('backToMainRoot', (event, goToHome, closeSession) => {
            this.GiftCardsUtilService.backToMain( goToHome, closeSession);
        });
        this.SecurityOtpService.initialize();
    };

    $onInit = this.active();
}

/**
 * Iberia Gift Cards Angular Application
 * @module ib-gift-cards-app
 */
InitApp.$inject = ['$translate', '$rootScope', 'GiftCardsAppConstants', 'CommonsLanguageAndMarketService', 'localStorageService',
    'GiftCardsUtilService', 'MonetateUtilsService', 'CommonsGetLoginInfoService', 'TranslateFactoryService',
    'CommonsSessionStorageService', 'GiftCardsDatalayerService', 'SecurityOtpService'
];
angular.module('ib-gift-cards-app', [
    'web-gift-cards-templates',
    'ngAria',
    'LocalStorageModule',
    'ib-commons-utils-module',
    'ib-commons-constants-module',
    'ib-commons-avios-constants',
    'ib-commons-filters-module',
    'pascalprecht.translate',
    'ng.deviceDetector',
    'ui.bootstrap',
    'ui.select',
    'ngMessages',
    'ngCookies',
    'ngSanitize',
    'duScroll',
    'rx',
    'tmh.dynamicLocale',
    'ib-gift-cards-configuration-module',
    'ib-commons-precondition-module',
    'ib-gift-cards-routing-module',
    'ib-gift-cards-service-module',
    'ib-gift-cards-generic-error-module',
    'ib-web-menus-module',
    'ib-datalayer-module',
    'ib-commons-login-module',
    'ib-commons-http-service-module',
    'ib-commons-modal-service-module',
    'ib-commons-proxies-module',
    'ib-commons-directives-module',
    'ib-pmt-module',
    'ib-pmt-order-confirmation-module',
    'ib-monetate-module',
    'ib-pmt-gift-cards-confirmation-module',
    'angular-bind-html-compile',
    'ib-content-parser-module',
    'ib-commons-keep-alive-module',
    'ib-interceptors-module',
    'ib-commons-ui-components-module',
    'ib-commons-http-new-service-module',
    'ib-gift-cards-payments',
    'ib-gift-cards-confirmation',
    'ib-gc-new-contribution',
    'ib-commons-http-new-service-module',
    'ib-gift-cards-component',
    'ib-gift-cards-theme',
    'ib-security-otp-module'

    
]).directive(
    'ibGiftCardsBannerPromotion',
    downgradeComponent({ component: IbGiftCardsBannerPromotionComponent }) as angular.IDirectiveFactory
);

angular.module('ib-gift-cards-app').run(InitApp);
